import { random } from 'lodash-es'

// 设备类型颜色映射表
const DEVICE_COLOR_MAP = {
  'eBlock522-4H': '#55DF6A',  // 绿色
  'eBlock522-2H': '#40A9F0',  // 蓝色
  'eBlock372': '#FFD700',     // 金色
  'eBlock418': '#F68C13',     // 橙色
  'eBlock418P': '#FF6B6B',    // 红色
  'eBlock261': '#9C27B0'      // 紫色
}

const colors = ['#55DF6A', '#40A9F0', '#FFD700', '#F68C13', '#FF6B6B', '#9C27B0']

export default function (chartData = []) {
  /**
   * @type {import('echarts').EChartsOption}
   */


  const ebList = chartData.filter(item => /^eBlock/.test(item.productModel))
  const deviceList = ebList.map(item => item.productModel);//['eBlock522-4H', 'eBlock522-2H','eBlock372', 'eBlock418','eBlock418P', 'eBlock261', 'eBlock100C', 'eBlock172', 'eBlock200'];

  // 为每个设备类型的数据项设置对应的颜色
  const dataWithColors = ebList.map((item, i) => ({
    value: item.count,
    itemStyle: {
      color: colors[i % colors.length]
    }
  }));


  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    title: {
      text: '设备类型分析',
      subtext: '已并网设备按类型统计其数量',
      left: 20,
      top: 10,
      textStyle: {
        color: '#000',
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'HarmonyOS Sans SC',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
    },
    grid: {
      top: 80,
      bottom: 40,
      left: 80,
      right: 40,
    },
    legend: {
      right: 60,
      top: 20,
      itemWidth: 10,
      itemHeight: 10,
      // data: deviceList,
    },
    xAxis: [
      {
        type: 'category',
        data: deviceList,
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          rotate: 15,
          interval: 0
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        // name: '个数',
        // min: 0,
        // max: 250,
        // interval: 50,
        axisLabel: {
          formatter: '{value} 个'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          }
        }
      },
    ],
    series: [
      {
        type: 'bar',
        barWidth: 16,
        data: dataWithColors,
        itemStyle: {
          // [左上角, 右上角, 右下角, 左下角]
          borderRadius: [4, 4, 0, 0]
        }
      }
    ]
  };


  return option
}

